<template>
  <!-- 第一层 -->
  <template v-for="item in menuItemData" :key="item.id">
    <template v-if="item.visible != '1'">
      <!-- 有子菜单 -->
      <template v-if="item.children && item.children.length > 0">
        <el-sub-menu :index="item.path">
          <template #title>
            <div class="el-icon">
              <component :is="item.icon" />
            </div>
            <span>{{ item.menuName }}</span>
          </template>

          <CommonMenuItemAside :menuItemData="item.children" />
        </el-sub-menu>
      </template>

      <!-- 无子菜单 -->
      <template v-else>
        <el-menu-item :index="item.path" @click="clickMenu(item)">
          <div class="el-icon">
            <component :is="item.icon" />
          </div>
          <span>{{ item.menuName }}</span>
        </el-menu-item>
      </template>
    </template>
  </template>
</template>

<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import CommonMenuItemAside from './CommonMenuItemAside.vue'

/* props */
const props = defineProps({
  menuItemData: {
    type: Array,
    required: true
  }
})

/* store / router */
const store = useStore()
const router = useRouter()
const route = useRoute()

/* 是否折叠 */
const isCollapse = computed(() => store.state.tab.isCollapse)

/* 点击菜单 */
function clickMenu(item) {
  if (!item.redirect) {
    store.dispatch('updateMenuItem', item)
    
    // if (checkRouter({ path: item.path })) {
      if (item.query && item.query.length > 0) {
        router.push(item.query + item.path)
      } else {
        
        router.push(item.path)
      }
    // }
  }
}

/* 匹配路由是否相同 */
function checkRouter(data) {
  return (
    route.path !== data.path &&
    !(route.path === '/dashboard' && data.path === 'dashboard') &&
    !(route.path === '/tenantList' && data.path === 'tenantList') &&
    !(route.path === '/userList' && data.path === 'userList') &&
    !(route.path === '/roleList' && data.path === 'roleList') &&
    !(route.path === '/menuList' && data.path === 'menuList') &&
    !(route.path === '/modelList' && data.path === 'modelList') &&
    !(route.path === '/resourceList' && data.path === 'resourceList') &&
    !(route.path === '/deptList' && data.path === 'deptList') &&
    !(route.path === '/logsList' && data.path === 'logsList') &&
    !(route.path === '/menuListTenant' && data.path === 'menuListTenant')
  )
}
</script>

<style scoped></style>
